export const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        iconClass: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'alerts',
      displayName: 'menu.alerts',
      meta: {
        iconClass: 'vuestic-iconset-auth',
      },
      // disabled: true,
      // children: [
      //   // {
      //   //   name: 'charts',
      //   //   displayName: 'menu.charts',
      //   // },
      // ],
    },
    // {
    //   name: 'templates',
    //   displayName: 'menu.templates',
    //   meta: {
    //     iconClass: 'vuestic-iconset-files',
    //   },
    //   // disabled: true,
    //   children: [
    //     {
    //       name: 'form-elements',
    //       displayName: 'menu.formElements',
    //     },
    //     {
    //       name: 'medium-editor',
    //       displayName: 'menu.mediumEditor',
    //     },
    //   ],
    // },
    {
      name: 'reports',
      displayName: 'menu.reports',
      meta: {
        iconClass: 'vuestic-iconset-tables',
      },
      children: [
        {
          name: 'reports-site-prod',
          displayName: 'Site Production kWh',
        },
        // {
        //   name: 'reports-inverter-prod',
        //   displayName: 'Inverter Production kWh',
        // },
      ],

    },

    {
      name: 'admin',
      displayName: 'menu.admin',
      meta: {
        iconClass: 'vuestic-ui-elements',
        isAdmin: true,
      },
      children: [
        {
          name: 'admin-users',
          displayName: 'Users',
        },
        {
          name: 'admin-accounts',
          displayName: 'Accounts',
        },

        {
          name: 'admin-sites',
          displayName: 'Sites',
        },
        {
          name: 'admin-gateways',
          displayName: 'Gateways',
        },

        // {
        //   name: 'reports-inverter-prod',
        //   displayName: 'Inverter Production kWh',
        // },
      ],

    },

    // {
    //   name: 'settings',
    //   displayName: 'menu.settings',
    //   meta: {
    //     iconClass: 'vuestic-iconset-settings',
    //   },
    //   disabled: true,
    // },
  ],
}
